module.exports = __webpack_public_path__ + "media/2x/C-e728cb08.png";